module.exports = __webpack_public_path__ + "img/flag-indonesia.3300e873.png";